import { ENV, ENV_ENUM, GTM_KEY } from '@/shared/config';
import _ from 'lodash';
import TagManager from 'react-server-side-gtm';
import auth from '../auth/auth';

/**
 * Reports whether Google Tag Manager tracking is permitted in the running environment. Compares the build environment against the customer environment.
 *
 * @returns True only in the customer environment.
 */
const isAllowedGtm = () => ENV === ENV_ENUM.customer;

/**
 * Boots Google Tag Manager with the signed-in user's identity and how they reached the portal. Uses the auth username, falling back to the user id when it reads 'null', derives userSource as direct, admin or sales from the login-origin checks, and in the customer environment points the tag script at the self-hosted ga.customer.biotricity.com origin before initialising TagManager.
 *
 * @returns Nothing.
 */
const initializeGtm = () => {
  const username = auth.username();
  const tagManagerArgs = {
    gtmId: GTM_KEY,
    dataLayer: {
      userId: username !== 'null' ? username : auth.userId(),
      userSource: auth.isLoginWithBiocarePortal()
        ? 'direct'
        : auth.isLoginThroughAdmin()
          ? 'admin'
          : auth.isLoginThroughSales()
            ? 'sales'
            : undefined,
    },
  };
  if (ENV === ENV_ENUM.customer) {
    _.assign(tagManagerArgs, {
      src: 'https://ga.customer.biotricity.com',
      jsDir: 'js',
      htmlDir: 'html',
    });
  }
  TagManager.initialize(tagManagerArgs);
};

/**
 * Pushes an analytics event onto the Google Tag Manager data layer. Forwards the payload to TagManager only in the customer environment, so other environments send nothing.
 *
 * @param data - Data layer payload to push.
 * @returns Nothing.
 */
const sendDataLayer = (data: any) => {
  if (ENV === ENV_ENUM.customer) {
    TagManager.dataLayer(data);
  }
};

export { initializeGtm, isAllowedGtm, sendDataLayer };
